'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _icons = require('./icons');

var _icons2 = _interopRequireDefault(_icons);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var extensions = {
  gif: _icons2.default.image,
  jpeg: _icons2.default.image,
  jpg: _icons2.default.image,
  png: _icons2.default.image,
  pdf: _icons2.default.pdf,
  doc: _icons2.default.word,
  docx: _icons2.default.word,
  ppt: _icons2.default.powerpoint,
  pptx: _icons2.default.powerpoint,
  xls: _icons2.default.excel,
  xlsx: _icons2.default.excel,
  csv: _icons2.default.csv,
  aac: _icons2.default.audio,
  mp3: _icons2.default.audio,
  ogg: _icons2.default.audio,
  avi: _icons2.default.video,
  flv: _icons2.default.video,
  mkv: _icons2.default.video,
  mp4: _icons2.default.video,
  gz: _icons2.default.archive,
  zip: _icons2.default.archive,
  css: _icons2.default.code,
  html: _icons2.default.code,
  js: _icons2.default.code,
  txt: _icons2.default.text
};
exports.default = extensions;